import { Instrument } from '../types';
import {
  GUITAR_TUNINGS,
  BASS_TUNINGS,
  UKULELE_TUNINGS,
  BANJO_TUNINGS,
} from './tunings';

/**
 * Predefined instruments with their tunings
 */
export const INSTRUMENTS: Record<string, Instrument> = {
  guitar: {
    name: 'Guitar (6-string)',
    stringCount: 6,
    defaultTuning: 'standard',
    tunings: GUITAR_TUNINGS,
  },

  bass4: {
    name: 'Bass Guitar (4-string)',
    stringCount: 4,
    defaultTuning: 'standard4',
    tunings: BASS_TUNINGS,
  },

  bass5: {
    name: 'Bass Guitar (5-string)',
    stringCount: 5,
    defaultTuning: 'standard5',
    tunings: BASS_TUNINGS,
  },

  ukulele: {
    name: 'Ukulele (Soprano/Concert/Tenor)',
    stringCount: 4,
    defaultTuning: 'standardC',
    tunings: UKULELE_TUNINGS,
  },

  ukuleleBari: {
    name: 'Ukulele (Baritone)',
    stringCount: 4,
    defaultTuning: 'baritone',
    tunings: UKULELE_TUNINGS,
  },

  banjo: {
    name: 'Banjo (5-string)',
    stringCount: 5,
    defaultTuning: 'openG',
    tunings: BANJO_TUNINGS,
  },
};

/**
 * Get instrument by name
 */
export function getInstrument(name: string): Instrument | null {
  return INSTRUMENTS[name] || null;
}

/**
 * Get available instrument names
 */
export function getInstrumentNames(): string[] {
  return Object.keys(INSTRUMENTS);
}
